<p-scrollPanel [style]="{ width: '100%', height: '100%' }">
<form [formGroup]="form.formGroup" class="flex flex-col">
  <div class="flex flex-1 flex-col pr-1">
  <div class="relative z-[2] flex flex-col space-y-2">
    <div class="flex flex-col">
      <label for="name">Name</label>
      <input id="name" type="text" pInputText [formControlName]="form.formControlNames.name" />
    </div>

    <div class="flex flex-col">
      <label for="thermalOperation">Previous Operation</label>
      <p-select id="thermalOperation" [options]="previousOperations" filter filterBy="name" resetFilterOnHide="true"
        [formControlName]="form.formControlNames.previousOperationId" optionLabel="name" optionValue="id"
        (onChange)="onPreviousOperationChanged($event)" appendTo="body">
      </p-select>
    </div>
  </div>

  <div class="mt-3">
    <p-tabs [(value)]="selectedTab">
      <div class="flex">
        <p-tablist>
          <p-tab value="0">{{ insideTabHeader }}</p-tab>
          @if (!circulationSelected) {
            <p-tab value="1">Annulus</p-tab>
          }
          <p-tab value="2">Ambient</p-tab>
        </p-tablist>

        @if (gasLiftSelected) {
          <label class="pl-5 pt-1 validation-error">Note: Gas Lift selected in the annulus<br>(Beta version - only works with Perforation pressure specified on the inside)</label>
        }
      </div>

      <p-tabpanels class="pl-2 pr-2">
        <p-tabpanel value="0">
          <app-single-operation [previousOperationMudPits]="previousOperationMudPits" [isReadOnly]="isReadOnly" [formControlName]="form.formControlNames.inside"
            [typeInput]="typeInput" [showScreenout]="showScreenout" (typeChanged)="onChildTypeChanged($event)"
            [tabType]="'inside'" [showRestartOperation]="showRestartOperation" (selectedTabChange)="operationDetailsSelectedTab = $event"
            (drillingDepthRangeUpdate)="drillingRangeChanged($event)" [user]="user" [units]="units" [wellType]="wellType"
            (fluidChanged)="onFluidChange($event)" [triggerMudPitTempChange]="triggerMudPitTempChange"></app-single-operation>
        </p-tabpanel>

        <p-tabpanel value="1">
          <app-single-operation [isReadOnly]="isReadOnly" [formControlName]="form.formControlNames.annulus"
            [typeInput]="typeInput" [showScreenout]="showScreenout" [defaultScreenoutHangerPressure]="defaultScreenoutHangerPressure" (typeChanged)="onChildTypeChanged($event)" [tabType]="'annulus'"
            [user]="user" [units]="units" [wellType]="wellType" [hasOilProperty]="hasOilProperty"></app-single-operation>
        </p-tabpanel>

        <p-tabpanel value="2">
          <div class="pb-4">
            <p-fieldset legend="Ambient Conditions">
              <div class="space-y-2">
                <div class="flex flex-col">
                  <label for="outsideDiameter">Air Velocity</label>
                  <p-inputgroup>
                    <p-inputnumber [minFractionDigits]="1" [formControlName]="form.formControlNames.airVelocitySurface" />
                    <p-inputgroup-addon>{{ speedUnit }}</p-inputgroup-addon>
                  </p-inputgroup>
                </div>

                <div [class.opacity-60]="wellType?.type === 'Land'" [class.pointer-events-none]="wellType?.type === 'Land'" class="flex flex-col">
                  <label for="insideDiameter">Ocean Current Velocity</label>
                  <p-inputgroup>
                    <p-inputnumber [minFractionDigits]="1" [formControlName]="form.formControlNames.seaCurrentVelocity" />
                    <p-inputgroup-addon>{{ speedUnit }}</p-inputgroup-addon>
                  </p-inputgroup>
                </div>
              </div>
            </p-fieldset>
          </div>
        </p-tabpanel>

        @if (hideTimeInput && operationDetailsSelectedTab === '0' && selectedTab !== '2') {
          <div class="grid grid-nogutter">
            <p-fieldset legend="Duration">
              @if (!restartOperationIncluded) {
              <div class="flex gap-2">
                <div style="align-content: center;">
                  @if (showFlowVolume) {
                    <div class="pb-2">
                      <input
                        class="radio-input"
                        value="volume"
                        type="radio"
                        binary="true"
                        (click)="volumeTimeChange(true)"
                        [checked]="form.formGroup.controls.volumeSelected.value"
                      />
                    </div>
                  }

                  @if (showFlowVolume) {
                    <div class="pt-6">
                      <input
                      value="volume"
                      type="radio"
                      binary="true"
                      (click)="volumeTimeChange(false)"
                      [checked]="!form.formGroup.controls.volumeSelected.value"
                      >
                    </div>
                  }
                </div>

              <div class="flex gap-2">
                <div class="space-y-2">
                  <div class="form-field">
                    <div class="input-group">

                      @if (!showRop && showFlowVolume) {
                        <div class="form-field">
                          <label for="volume">Volume</label>
                          <p-inputgroup>
                            <p-inputNumber
                              [minFractionDigits]="1"
                              [formControlName]="form.formControlNames.volumeValue"
                              (focusout)="volumeChange($event, null)"
                            ></p-inputNumber>
                            <p-select
                              [disabled]="isReadOnly"
                              [options]="volumeOptions"
                              optionLabel="name"
                              optionValue="value"
                              appendTo="body"
                              (onChange)="volumeChange(null, $event)"
                              [formControlName]="form.formControlNames.volumeSelection"
                            ></p-select>
                          </p-inputgroup>
                        </div>
                      }
                    </div>
                  </div>

                  <div class="field">
                    <div class="p-input-group">

                      @if (showRop) {
                        <div class="field">
                          <label for="time">ROP ({{ user.units.longLengths }}/hr)</label>
                          <p-inputgroup>
                            <input id="rop" type="number" pInputText value="{{ defaultRop }}" (change)="ropChange($event)" />
                          </p-inputgroup>
                        </div>
                      }
                      <div class="field">
                        <label htmlFor="time">{{ timeInputLabel }}</label>
                        <p-inputgroup>
                          <p-inputNumber
                            [minFractionDigits]="1"
                            [formControlName]="form.formControlNames.time"
                            (focusout)="timeChange($event)"
                          ></p-inputNumber>
                          <p-select [options]="timeUnits"
                            [formControlName]="form.formControlNames.timeUnits" optionLabel="name" optionValue="value"
                            appendTo="body" (onChange)="timeChange(null)"></p-select>
                        </p-inputgroup>
                    </div>
                  </div>
                </div>

              </div>
              </div>
            </div>
            }
            @if (restartOperationIncluded) {
              <input type="number" pInputText placeholder="Restart Operation Enabled" [disabled]="true" />
            }
          </p-fieldset>
        </div>
        }
      </p-tabpanels>
    </p-tabs>
  </div>
  </div>
</form>
</p-scrollPanel>

<!-- <pre>{{ form.formGroupErrors | json }}</pre> -->